import { RouletteOptionsClasses } from '../enums/RouletteOptionsClasses';
export var ROULETTE_OPTIONS_WITH_ITEM = [
    RouletteOptionsClasses.STRAIGHT,
    RouletteOptionsClasses.SPLIT,
    RouletteOptionsClasses.STREET,
    RouletteOptionsClasses.SQUARE,
    RouletteOptionsClasses.FIVE,
    RouletteOptionsClasses.DOUBLE_STREET,
    RouletteOptionsClasses.COLUMN,
    RouletteOptionsClasses.DOZEN,
];
export var ROULETTE_OPTIONS_WITHOUT_ITEM = [
    RouletteOptionsClasses.ODD,
    RouletteOptionsClasses.EVEN,
    RouletteOptionsClasses.RED,
    RouletteOptionsClasses.BLACK,
    RouletteOptionsClasses.LOW,
    RouletteOptionsClasses.HIGH,
];
